import { styled } from 'styled-components';

export const SearchHeroBackgroundHolder = styled.div`
  position: absolute;
  transform: translateZ(0);
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const SearchHeroBackgroundImageHolder = styled.div`
  width: 100%;
  height: 100%;
`;
